import { useAuth } from "../context/AuthContext";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import useSize from "../Utils/useSize/useSize";
import { useState, useEffect } from "react";
import { useMediaQuery } from "react-responsive";

import Login from "../Screen/Login/Login/Login";
import Register from "../Screen/Login/Register/Register";
import CPassword from "../Screen/Login/CPassword/CPassword";
import Rules from "../Screen/Rules/Rules";
import User from "./User";
import UserMobile from "./UserMobile"; // 📱 mobile version
import Privacy from "../Screen/Login/Privacy/Privacy";
import Terms from "../Screen/Login/Terms/Terms";
import DeleteAccount from "../Screen/Login/DeleteAccount/DeleteAccount";

export default function Navigation() {
  const { isLoggedIn } = useAuth();
  const windowSize = useSize();

  const userType = Number(localStorage.getItem("user_type") || 7);

  const [acceptedRules, setAcceptedRules] = useState(false);

  const isMobile = useMediaQuery({ maxWidth: 767 });

  // ✅ Load persisted rule acceptance
  useEffect(() => {
    const accepted = localStorage.getItem("acceptedRules") === "true";
    setAcceptedRules(accepted);
  }, []);

  const handleAcceptRules = () => {
    setAcceptedRules(true);
    localStorage.setItem("acceptedRules", "true");
  };

  return (
    <div style={{ height: windowSize[1] }}>
      <Router>
        {isLoggedIn ? (
          acceptedRules ? (
            isMobile ? (
              userType === 4 ? (
                <UserMobile />
              ) : (
                <User />
              )
            ) : (
              <User />
            )
          ) : (
            <Rules onAccept={handleAcceptRules} />
          )
        ) : (
          <Routes>
            <Route path="*" element={<Login />} />
            <Route path="/" element={<Login />} />
            <Route path="/Login" element={<Login />} />
            <Route path="/CPassword" element={<CPassword />} />
            <Route path="/Register" element={<Register />} />
            <Route path="/Privacy" element={<Privacy />} />
            <Route path="/Terms" element={<Terms />} />
            <Route path="/deleteaccount" element={<DeleteAccount />} />
          </Routes>
        )}
      </Router>
    </div>
  );
}
